(() => {
  function init(scope) {
    scope.querySelectorAll('[data-emh-visualizer]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const get = name => root.querySelector(`[data-emh-${name}]`);
      const form = get('visualizer-form'), input = get('room-input'), room = get('room-preview');
      const result = get('result'), actions = get('result-actions'), loading = get('loading');
      const status = get('status'), submit = get('submit'), price = get('pricechip');
      const lights = [...root.querySelectorAll('[data-emh-light]')];
      let selected, roomUrl, busy = false;
      const track = event => { if (typeof window.fbq === 'function') window.fbq('trackCustom', event, {page:location.pathname}); };
      function clearResult() {
        result.hidden = true; actions.hidden = true; price.hidden = true;
        room.hidden = !roomUrl; get('empty').hidden = Boolean(roomUrl);
      }
      function choose(button) {
        if (busy) return;
        lights.forEach(light => {
          const active = light === button;
          light.classList.toggle('is-selected', active);
          light.setAttribute('aria-pressed', String(active));
        });
        selected = {...button.dataset};
        get('product-preview').src = selected.image;
        get('product-preview').alt = selected.title;
        get('product-name').textContent = `${selected.title} · ${selected.price}`;
        get('product-choice').hidden = false;
        clearResult();
        status.textContent = roomUrl ? 'Ready to preview this fitting in your room.' : '';
      }
      lights.forEach(button => button.addEventListener('click', () => choose(button)));
      if (lights.length) choose(lights[0]);
      else {
        submit.disabled = true;
        status.textContent = 'No fittings are available in this collection right now. Ask us on WhatsApp for help choosing.';
      }
      input.addEventListener('change', () => {
        if (roomUrl) URL.revokeObjectURL(roomUrl);
        roomUrl = undefined;
        room.removeAttribute('src');
        clearResult();
        status.textContent = '';
        const file = input.files[0];
        if (!file) return;
        if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
          input.value = '';
          status.textContent = 'Choose a JPG, PNG or WebP image no larger than 10 MB.';
          return;
        }
        roomUrl = URL.createObjectURL(file);
        room.src = roomUrl;
        clearResult();
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const file = input.files[0];
        if (!file || !selected) {status.textContent = 'Upload your room and choose a light first.'; return;}
        const selection = {...selected};
        const data = new FormData();
        data.append('room', file);
        data.append('product_id', selection.value);
        data.append('product_title', selection.title);
        data.append('product_image', new URL(selection.image, location.href).href);
        busy = true; submit.disabled = true; input.disabled = true;
        lights.forEach(button => {button.disabled = true;});
        clearResult(); loading.hidden = false; status.textContent = '';
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 120000);
        track('RoomPreviewStarted');
        try {
          const response = await fetch('https://emalove-visualizer-production-dd00.up.railway.app/transform', {method:'POST',body:data,signal:controller.signal});
          if (!response.ok) throw new Error('service');
          const payload = await response.json();
          const image = payload.image_url || payload.image;
          if (typeof image !== 'string' || !/^https:\/\//i.test(image)) throw new Error('image');
          await new Promise((resolve, reject) => {
            const cancel = () => finish(new Error('image'));
            function finish(error) {
              result.onload = result.onerror = null;
              controller.signal.removeEventListener('abort', cancel);
              error ? reject(error) : resolve();
            }
            result.onload = () => finish();
            result.onerror = () => finish(new Error('image'));
            controller.signal.addEventListener('abort', cancel, {once:true});
            if (controller.signal.aborted) return cancel();
            result.src = image;
          });
          get('download').href = image;
          get('pc-title').textContent = selection.title;
          get('pc-price').textContent = selection.price;
          const buy = get('buy');
          const url = new URL(buy.href);
          url.searchParams.set('text', `Hi Emalove — I previewed ${selection.title} (${selection.price}) in my room. Please help me confirm dimensions, availability and the full quote. Page: ${location.pathname}`);
          buy.href = url.href;
          result.hidden = false; room.hidden = true; actions.hidden = false; price.hidden = false;
          status.textContent = 'Your preview is ready. Download it, or choose another fitting to compare.';
          track('RoomPreviewCompleted');
        } catch (error) {
          clearResult();
          status.textContent = controller.signal.aborted ? 'The preview is taking too long. Please try again, or ask us on WhatsApp.' : 'We could not create your preview. Please try again, or ask us on WhatsApp.';
        } finally {
          clearTimeout(timer); busy = false; loading.hidden = true;
          submit.disabled = false; input.disabled = false;
          lights.forEach(button => {button.disabled = false;});
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
